import { render, staticRenderFns } from "./areaSelect.vue?vue&type=template&id=cbbda188&scoped=true"
import script from "./areaSelect.vue?vue&type=script&lang=js"
export * from "./areaSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbda188",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbbda188')) {
      api.createRecord('cbbda188', component.options)
    } else {
      api.reload('cbbda188', component.options)
    }
    module.hot.accept("./areaSelect.vue?vue&type=template&id=cbbda188&scoped=true", function () {
      api.rerender('cbbda188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/multiLvSelectArea/areaSelect.vue"
export default component.exports